import axios from 'axios';

const interceptor = axios.create()

export  default interceptor;
  

